"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getFolderMruConfigurationOperation_1 = require("owa-service/lib/operation/getFolderMruConfigurationOperation");
/**
 * Action to get folder MRU Configuration
 * @return the TargetFolderMruConfiguration
 */
function getFolderMruConfigurationService() {
    return getFolderMruConfigurationOperation_1.default().then(function (response) {
        return response;
    });
}
exports.default = getFolderMruConfigurationService;
//# sourceMappingURL=getFolderMruConfigurationService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-move-mru/lib/services/getFolderMruConfigurationService.js
// module id = 1842
// module chunks = 23 62 105 108